import { Link } from './styles';

export default Link;
